import React from 'react';
import Container from './ui/Container';
import Button from './ui/Button';

export default function FooterCTA({ content }) {
  return (
    <section id="closing-cta" className="py-24 bg-white scroll-mt-20 no-print">
      <Container className="text-center">
        <h2 className="text-3xl font-bold text-slate-900 mb-10">
          {content.heading}
        </h2>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button href="#enquiry-form" variant="primary" className="w-full sm:w-auto">
            {content.primaryButton}
          </Button>
          <Button href="https://calendly.com/bpasolutions" variant="secondary" className="w-full sm:w-auto">
            {content.secondaryButton}
          </Button>
        </div>
      </Container>
    </section>
  );
}